export default function loadingFull(state = false, action) {
  switch (action.type) {
    case "LOADINGFULL":
      return action.loadingFull;

    default:
      return state;
  }
}
